if (!customElements.get('product-description-show-more')) {
  customElements.define(
    'product-description-show-more',
    class ProductDescriptionShowMore extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        const descriptionContainer = this.closest('.product__description--show-more');
        if (!descriptionContainer) return;

        const content = descriptionContainer.querySelector('.product__description-content');
        const showMoreButton = descriptionContainer.querySelector('show-more-button');
        
        if (!content || !showMoreButton) return;

        // Check if content is short enough to not need show more
        this.checkContentLength(content, showMoreButton, descriptionContainer);

        // Add click event listener
        const button = showMoreButton.querySelector('button');
        if (button) {
          button.addEventListener('click', () => {
            this.toggleContent(descriptionContainer, showMoreButton);
          });
        }
      }

      checkContentLength(content, showMoreButton, container) {
        // Check if there's overflow (content is clipped)
        const hasOverflow = content.scrollHeight > content.clientHeight;
        
        // If no overflow, hide the button with visibility
        if (!hasOverflow) {
          showMoreButton.style.visibility = 'hidden';
        } else {
          showMoreButton.style.visibility = 'visible';
        }
      }

      
      toggleContent(container, showMoreButton) {
        const isExpanded = container.classList.contains('expanded');
        
        if (isExpanded) {
          container.classList.remove('expanded');
        } else {
          container.classList.add('expanded');
        }

        // Toggle button labels
        const showMoreLabel = showMoreButton.querySelector('.label-show-more');
        const showLessLabel = showMoreButton.querySelector('.label-show-less');
        
        if (showMoreLabel && showLessLabel) {
          showMoreLabel.classList.toggle('hidden');
          showLessLabel.classList.toggle('hidden');
        }
      }
    }
  );
}

// Initialize all product description show more elements
document.addEventListener('DOMContentLoaded', function() {
  const descriptionElements = document.querySelectorAll('.product__description--show-more');
  descriptionElements.forEach(element => {
    if (!element.querySelector('product-description-show-more')) {
      const showMoreElement = document.createElement('product-description-show-more');
      element.appendChild(showMoreElement);
    }
  });
});
